import { render, staticRenderFns } from "./SPRSearchBox.vue?vue&type=template&id=e2e52d00&scoped=true"
import script from "./SPRSearchBox.vue?vue&type=script&lang=ts"
export * from "./SPRSearchBox.vue?vue&type=script&lang=ts"
import style0 from "./SPRSearchBox.vue?vue&type=style&index=0&id=e2e52d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e52d00",
  null
  
)

export default component.exports